module.exports = __webpack_public_path__ + "img/funnel-planplaceholder.a2c43b17.png";